import React from 'react';
import PropTypes from 'prop-types';
import { Chip } from '@mui/material';
import { EMAIL_CAMPAIGN_RECIPIENTS_STATUS } from '../../config/const.config';

const EmailCampaignRecipientsLabel = ({ value }) => {
  const label = EMAIL_CAMPAIGN_RECIPIENTS_STATUS[value].label || 'Unknown';
  const color = EMAIL_CAMPAIGN_RECIPIENTS_STATUS[value].color || 'primary';

  return <Chip label={label} color={color} variant="filled" size="small" />;
};

EmailCampaignRecipientsLabel.propTypes = {
  value: PropTypes.number.isRequired,
};

export default EmailCampaignRecipientsLabel;
